export const ROUTE_UNIDAD_NEGOCIO = 'administracion-pg:unidad-negocio'

export const ROUTE_ESTABLECIMIENTO = 'administracion-pg:establecimiento'

export const ROUTE_MACRODEPARTAMENTO = 'administracion-pg:macrodepartamento'

export const ROUTE_DEPARTAMENTO = 'administracion-pg:departamento'

export const ROUTE_EDIFICIO = 'administracion-pg:edificio'

export const ROUTE_PROCESO = 'administracion-pg:proceso'

export const ROUTE_AREA = 'administracion-pg:area'
